import { Form, Input, Modal, TreeSelect, Button, Select } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import { transformToTreeSelectOptions } from '../utils';
import {
  apiV2AreaAddPost,
  apiV2AreaEditPost,
  apiV2AreaTreePost,
  apiV2AreaViewPost,
  apiV2AreaCategoryListPost,
} from '@maxtropy/device-customer-apis-v2';
import { parentInfo } from '..';
import { Space } from 'antd';
export const MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
};
export type ComponentMode = (typeof MODE)[keyof typeof MODE];

type Props = {
  mode?: ComponentMode;
  currentNodeId?: number;
  createInfo?: parentInfo;
  closeModal: () => void;
  update: () => void;
};

const getComponentMode = (mode: ComponentMode) => {
  return {
    isView: mode === 'view',
    isEdit: mode === 'edit',
    isAdd: mode === 'create',
  };
};

const CreateorViewArea = ({ mode, closeModal, currentNodeId, createInfo, update }: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { isView, isEdit, isAdd } = getComponentMode(mode!);
  const [option, setOption] = useState<any>([]);
  const [categoryOptions, setCategoryOptions] = useState<{ value: number; label: string }[]>([]);

  // 获取分类数据
  useEffect(() => {
    apiV2AreaCategoryListPost({}).then(res => {
      const list = res.list || [];
      const options = list
        .filter(item => item.index !== undefined && item.index !== null)
        .sort((a, b) => a.index! - b.index!)
        .map(item => ({
          value: item.id as number,
          label: item.description || `分类${item.index}`,
        }));
      setCategoryOptions(options);
    });
  }, []);

  useEffect(() => {
    apiV2AreaTreePost({}).then(data => {
      const dataList = data.list || [];

      const options = transformToTreeSelectOptions(dataList);
      setOption(options);
    });
  }, []);

  useEffect(() => {
    if (isAdd) {
      form.setFieldsValue({
        parentLevel: createInfo?.parentId,
      });
    } else {
      apiV2AreaViewPost({ id: currentNodeId }).then(res => {
        form.setFieldsValue({
          zoneName: res.zoneName,
          parentLevel: res.parentId,
          gasSupplyPipeline: res.gasSupplyPipeline,
          areaCategoryId: res.areaCategoryId,
        });
      });
    }
  }, []);

  const onFinish = (values: any) => {
    setLoading(true);
    const params = {
      zoneName: values.zoneName,
      parentId: values.parentLevel,
      gasSupplyPipeline: values.gasSupplyPipeline,
      areaCategoryId: values.areaCategoryId,
    };

    if (isEdit) {
      apiV2AreaEditPost({
        ...params,
        id: currentNodeId,
      })
        .then(() => {
          closeModal();
          update();
        })
        .finally(() => setLoading(false));
    }
    if (isAdd) {
      apiV2AreaAddPost(params)
        .then(() => {
          closeModal();
          update();
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <Modal
      title={isAdd ? '新建区域' : isEdit ? '编辑区域' : '查看'}
      open={true}
      onCancel={() => closeModal()}
      contentClassName="modal-form-content"
      footer={
        isView ? (
          <Button onClick={() => closeModal()}>关闭</Button>
        ) : (
          <Space size="middle">
            <Button onClick={() => closeModal()}>取消</Button>
            <Button type="primary" loading={loading} onClick={() => form.submit()}>
              确定
            </Button>
          </Space>
        )
      }
    >
      <Form
        form={form}
        onFinish={onFinish}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            form.submit();
          }
        }}
      >
        <Form.Item
          name="zoneName"
          label="区域名称"
          rules={[
            { required: true, message: '请先输入区域名称' },
            { max: 50, message: '1~50个字符' },
          ]}
        >
          <Input placeholder="请输入名称" disabled={isView} />
        </Form.Item>

        <Form.Item name="areaCategoryId" label="分类" rules={[{ required: true, message: '请选择分类' }]}>
          <Select placeholder="请选择分类" options={categoryOptions} disabled={isView} allowClear />
        </Form.Item>

        <Form.Item label="上级区域" name="parentLevel">
          <TreeSelect
            placeholder="请选择上级区域"
            treeData={option}
            disabled={isView}
            showSearch
            allowClear
            filterTreeNode={(search, node) => {
              const searchText = (node.title ?? '') as string;
              return searchText.toLowerCase().includes(search.toLowerCase());
            }}
          />
        </Form.Item>
        <Form.Item name="gasSupplyPipeline" label="区域供气管道" rules={[{ max: 50, message: '最多输入50个字符' }]}>
          <Input.TextArea placeholder="请输入" disabled={isView} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateorViewArea;
